import * as React from "react";
import { HashRouter as Router } from "react-router-dom";
import { Helmet } from "react-helmet";

import faviconURL from "@assets/images/favicon-32x32.png";

import { ROUTES } from "@config/app.routing";
import { IS_BROWSER } from "@config/consts";

import { URLParamsHandler } from "@features/URLParamsHandler";

import { SmartlookClient } from "@containers/SmartlookClient";
import { Cookiebot } from "@containers/Cookiebot";
import { OverlayLockScroll } from "@containers/OverlayLockScroll";
import { ToastContainer } from "@containers/Toastify";

import {
  LocalStoragePurger,
  VersionReporter,
  VoucherInterceptor,
  DefaultLayoutApp,
  ImpersonateChecker,
  Analytics,
  BodyBgController,
  FocusModeController,
  UserNotificationHandler,
} from "@app/containers";

import AppProviders from "./App.providers";
import AppSwitch from "./App.switch";

const AppComponent = (): React.ReactElement => {
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" type="image/png" href={faviconURL} />
      </Helmet>

      <AppProviders>
        <Router>
          <Cookiebot />
          <VersionReporter />
          <VoucherInterceptor />
          <LocalStoragePurger />
          <SmartlookClient
            urlWhitelist={[ROUTES.BOOKING, ROUTES.END_OF_TENANCY, ROUTES.B2B]}
          />

          <DefaultLayoutApp>
            <FocusModeController />
            <BodyBgController />
            <ImpersonateChecker />
            <Analytics />
            <AppSwitch />
          </DefaultLayoutApp>

          <OverlayLockScroll />
          <ToastContainer />
          {IS_BROWSER && <UserNotificationHandler />}
          {IS_BROWSER && <URLParamsHandler />}
        </Router>
      </AppProviders>
    </React.Fragment>
  );
};

export { AppComponent as App };
